import { deleteVotingSession } from "../../api/voting";
import { IVotingSession } from "../../models/IVoting";
import { ConfirmDialog, DescriptionList, Tag } from "../../ui";
import "./styles.scss";

type DeleteVotingSessionDialogProps = {
  votingSession: IVotingSession;
  isOpen: boolean;
  onClose: (update?: boolean) => void;
};

const DeleteVotingSessionDialog = (props: DeleteVotingSessionDialogProps) => {
  // A failed delete throws: ConfirmDialog stays open (error handling is done in the API interceptor)
  const handleDelete = () => deleteVotingSession(props.votingSession.id);

  return (
    <ConfirmDialog
      open={props.isOpen}
      onClose={(confirmed) => props.onClose(confirmed || undefined)}
      onConfirm={handleDelete}
      title="Delete Voting Session"
      message="This action cannot be undone. If you delete this voting session, you will lose all votes and voting data."
      confirmLabel="Delete Session"
    >
      <div className="delete-voting-session-dialog__details">
        <p className="delete-voting-session-dialog__label">Session Details:</p>
        <DescriptionList
          columns={1}
          items={[
            {
              label: "Status:",
              value: (
                <Tag tone={props.votingSession.isOpen ? "ok" : "neutral"}>{props.votingSession.isOpen ? "Open" : "Closed"}</Tag>
              ),
            },
            {
              label: "Eligible Voters:",
              value: props.votingSession.eligibleVoterType === 0 ? "All Users" : "Participants Only",
            },
            { label: "Created:", value: new Date(props.votingSession.createdAt).toLocaleDateString() },
          ]}
        />
      </div>
    </ConfirmDialog>
  );
};

export default DeleteVotingSessionDialog;
